import { Link } from 'gatsby'
import React from 'react'
import BrandCard from './BrandCard'
import EcogestureCard from './EcogestureCard'
import OrganizationCard from './OrganizationCard'
import SidebarBanner from './Banners/SidebarBanner'

export const Sidebar = ({ relatedOrganizations, relatedBrands, blogPosts, ecogesture }) => {
  const indexableBrands = relatedBrands?.length > 0 ? relatedBrands.filter(({ indexable, affiliate }) => indexable === true && affiliate === true) : []

  return (
    <div className="p-4 w-full lg:w-1/4 inline-block">
      <div className="mb-2 p-2 pt-0 lg:mb-4 w-full mx-auto">
        <SidebarBanner />
      </div>

      {indexableBrands.length > 1 && (
        <div className="mb-4 lg:mb-8 w-full mx-auto">
          <h2 className="font-bold text-lg text-gray-600 px-1 mb-2">
            Marques liées à cet article
          </h2>

          <section className="flex">
            {indexableBrands.map(({ id, ...brand }) => (
              <BrandCard
                key={`sidebar-related-brand-${id}`}
                className="inline-block m-1"
                external={true}
                {...brand}
              />
            )
            )}
          </section>
        </div>
      )}

      {relatedOrganizations?.length > 0 && (
        <div className="mb-4 lg:mb-8 w-full mx-auto">
          <h2 className="font-bold text-lg text-gray-600 px-1 mb-2">
            Entreprises ou Associations liées à cet article
          </h2>

          <section className="flex">
            {relatedOrganizations.map(
              ({
                name,
                identifier,
                logo,
                type: { slug: typeSlug },
              }) => (
                <OrganizationCard
                  key={`related-organization-${identifier}`}
                  className="m-1 mx-2 w-24 h-24 inline-block"
                  slug={`/${typeSlug}/${identifier}/`}
                  name={name}
                  logo={logo}
                  loading="eager"
                />
              )
            )}
          </section>
        </div>
      )}

      <div className="mb-4 lg:mb-8 w-full mx-auto">
        <h2 className="font-bold text-lg text-gray-600 px-1 mb-2">
          Les derniers articles
        </h2>

        <section className="block p-1 prose">
          <ul className="list-reset">
            {blogPosts.map(
              ({ node: { category, slug, title, id } }) => (
                <li key={`news-blog-post-${id}`} className="m-1">
                  <Link
                    to={`/${category.slug}/${slug}/`}
                    title={title}
                  >
                    {title}
                  </Link>
                </li>
              )
            )}
          </ul>
        </section>
      </div>

      {ecogesture && (
        <div className="mb-4 lg:mb-8 w-full mx-auto">
          <h2 className="font-bold text-lg text-gray-600 px-1 mb-2">
            Eco Geste du jour
          </h2>

          <section className="block p-1">
            <EcogestureCard
              {...ecogesture}
              loading="lazy"
            />
          </section>
        </div>
      )}
    </div>
  )
}
